import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useLiveViewers } from '../hooks/useLiveViewers';
import { scrollToForm } from '../utils/scroll';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const viewers = useLiveViewers();
  const {
    scrollYProgress
  } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001
  });
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <motion.nav initial={{
    y: -70
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.7,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed inset-x-0 top-0 z-[1000] border-b border-brand-yellow/20 backdrop-blur-md transition-colors duration-300 ${scrolled ? 'bg-brand-deep/95' : 'bg-brand-deep/80'}`} data-id="element-190" data-mp="1px9rqnzta0jx">
      <div className={`flex items-center justify-between px-6 transition-all duration-300 ${scrolled ? 'py-2.5' : 'py-4'}`} data-id="element-191" data-mp="epdknphf8ns6">
        <div className="font-display text-xl font-extrabold tracking-tight text-white" data-id="element-192" data-mp="ol8ap5nz5l4z">
          Ultimate <span className="text-brand-yellow" data-id="element-193" data-mp="3n4p26zxph6xm">Web</span> Creator
        </div>
        <div className="ml-auto mr-4 hidden items-center gap-2 rounded-full border border-brand-green/40 bg-white/[0.07] px-3.5 py-1.5 sm:flex" data-id="element-194" data-mp="3s1nure1q15tp">
          <VisibilityIcon sx={{
          fontSize: 15
        }} className="text-brand-green" data-id="element-195" data-mp="u2x6x5ib4xu" />
          <span className="relative flex h-1.5 w-1.5" data-id="element-196" data-mp="5offv4z5sc8j">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-green opacity-75" data-id="element-197" data-mp="34debojvw6w69" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand-green" data-id="element-198" data-mp="39axnze914yvk" />
          </span>
          <span className="text-xs font-bold text-white" data-id="element-199" data-mp="319yr2isofwbx">{viewers}</span>
          <span className="text-[11px] text-white/60" data-id="element-200" data-mp="2wcq8ih3m9qa5">viendo ahora</span>
        </div>

        <button type="button" onClick={scrollToForm} className="group relative inline-flex items-center gap-2 overflow-hidden rounded-full bg-brand-yellow px-5 py-2.5 text-sm font-bold text-brand-deep transition hover:-translate-y-px hover:shadow-glow focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-deep" data-id="element-201" data-mp="3b0tevrlkn3zh">
          <span aria-hidden="true" className="absolute inset-y-0 -left-1/3 w-1/3 skew-x-12 bg-white/60 blur-md transition-transform duration-700 group-hover:translate-x-[420%]" data-id="element-202" data-mp="2sav3p2mh8urm" />
          <RocketLaunchIcon sx={{
          fontSize: 16
        }} data-id="element-203" data-mp="7j1ebotddbpo" />
          Cotiza Ahora
        </button>
      </div>

      <motion.div aria-hidden="true" style={{
      scaleX: progress
    }} className="h-0.5 origin-left bg-brand-yellow" data-id="element-204" data-mp="2khsdoerzzxb" />
    </motion.nav>;
}